<div class="bypasscode_container bypasscode_is-fullbleed">
  <div class="bypasscode_container__col">
    <div class="bypasscode_container bypasscode_is-fullbleed bypasscode_is-adjacent">
      <div class="bypasscode_container__col">
        <div class="bypasscode_user-banner">
          <div class="bypasscode_user-info">
            <div class="bypasscode_user-info__avatar">
              <svg
                aria-hidden="true"
                focusable="false"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                width="50"
                height="50"
                class="svg-inline--fa fa-user fa-w-14 fa-3x"
              >
                <path
                  fill="currentColor"
                  d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                ></path>
              </svg>
            </div>

            <div class="mfa_chall_mfa mfa_chall_mfa--container-verify-code">
              <h1 class="mfa_chall_mfa__title" id="verify-code-title" tabindex="0" aria-live="polite">
                Enter the code you received
              </h1>
              <div class="mfa_chall_mfa__section mfa_chall_text--left">
                <p class="mfa_chall_mfa__desc mfa_chall_mfa__desc--change-security">
                  Enter code <span aria-hidden="true">*</span>
                  <span class="mfa_chall_no-break"></span>
                </p>
              </div>
              <form
                [formGroup]="mfaForm"
                (ngSubmit)="onSubmit()"
                class="mfa_chall_form mfa_chall_form--inverse js-form"
                aria-labelledby="verify-code-title"
              >
                <div class="mfa_chall_form__row">
                  <label class="mfa_chall_form__input-label mfa_chall_form__item mfa_chall_form__input-container">
                    <input
                      type="text"
                      class="mfa_chall_form__input js-form-input is-required"
                      inputmode="numeric"
                      autocomplete="one-time-code"
                      [formControlName]="'securityCode'"
                      aria-describedby="securityCode-error"
                      aria-required="true"
                      [attr.aria-label]="isError ? errorMsg : 'Enter the security code you received'"
                    />
                    <span
                      id="securityCode-error"
                      aria-live="assertive"
                      style="
                        height: 21px;
                        letter-spacing: 0.46px;
                        color: #d0021b;
                        font-size: 14px;
                        font-family: 'Sul Sans';
                      "
                      >{{ isError ? errorMsg : ' ' }}</span
                    >
                  </label>
                </div>
                <div class="mfa_chall_form__row">
                  <button
                    type="submit"
                    class="mfa_chall_button mfa_chall_button--arrow mfa_chall_button--secondary mfa_chall_button--small js-form-submit"
                  >
                    <span>Continue</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
